import LegalLayout from "@/pages/LegalLayout";

export default function KullanimSartlari() {
  return (
    <LegalLayout title="Kullanım Şartları">
      <p className="text-sm text-zinc-500">
        Son güncelleme: {new Date().toLocaleDateString("tr-TR")}
      </p>

      <h2>1. Taraflar ve Kabul</h2>
      <p>
        Kolay Arşivim uygulaması ("Uygulama"), hizmeti kullanan kullanıcıya
        ("Kullanıcı") aşağıdaki şartlar altında sunulur. Uygulamayı kullanmakla
        bu şartları kabul etmiş sayılırsınız.
      </p>

      <h2>2. Hizmet Kapsamı</h2>
      <p>
        Uygulama, gayrimenkul değerleme uzmanlarına saha ekspertiz kayıtlarını
        harita üzerinde tutma ve yönetme imkânı sunar. Uygulamada girilen
        veriler Kullanıcı'nın kendi mesleki değerlendirmesidir ve resmi bir
        değerleme raporu yerine geçmez.
      </p>

      <h2>3. Kullanıcı Yükümlülükleri</h2>
      <ul>
        <li>Girilen bilgilerin doğruluğundan Kullanıcı sorumludur.</li>
        <li>Şifre gizliliği ve hesabının güvenliği Kullanıcı'ya aittir.</li>
        <li>Uygulamayı yasal düzenlemelere aykırı, üçüncü kişilerin haklarını
          ihlal edecek veya sistemi kötüye kullanacak şekilde kullanmak yasaktır.</li>
        <li>Otomatik toplama, scraping, aşırı istek veya benzeri kötüye kullanım
          hâlinde hesap askıya alınabilir.</li>
      </ul>

      <h2>4. Yasak İçerikler — Üçüncü Kişilere Ait Kişisel Veri</h2>
      <p>
        Uygulama, kullanıcıya <strong>kendi mesleki notlarını</strong> tutması
        için tasarlanmıştır. Üçüncü kişilere ait <strong>kişisel veri</strong>
        (KVKK Md. 3) niteliğindeki hiçbir bilgi Uygulamaya girilmemelidir.
        Aşağıdaki bilgiler <strong>kesinlikle yüklenemez</strong>:
      </p>
      <ul>
        <li>Müşteri, taşınmaz sahibi veya üçüncü kişilerin <strong>ad-soyad</strong>ları</li>
        <li><strong>Telefon numarası</strong>, e-posta veya adres gibi iletişim bilgileri</li>
        <li><strong>T.C. Kimlik Numarası</strong>, pasaport, vergi kimlik numarası</li>
        <li>IBAN, kredi kartı, hesap numarası vb. <strong>banka bilgileri</strong></li>
        <li>Resmi <strong>ekspertiz raporu</strong>, tapu senedi veya kredi belgeleri</li>
        <li>Sözleşme, vekaletname, kimlik fotokopisi gibi <strong>gizli belgeler</strong></li>
        <li>Kullanıcının veri sorumlusu sıfatıyla topladığı, kendisi dışında bir
          gerçek kişiye ait herhangi bir <strong>kişisel veri</strong></li>
      </ul>
      <p>
        <strong>Notlar alanı</strong> yalnızca taşınmazın kendisine ilişkin
        objektif gözlem (örn. yapı yaşı, cephe yönü, tadilat durumu) için
        kullanılmalıdır. Kişi ismi veya iletişim bilgisi içeren notlar
        girildiği tespit edilirse ilgili kayıt tebligatsız silinebilir ve hesap
        askıya alınabilir. Kullanıcı, bu türden veri girmesi hâlinde KVKK
        karşısında <strong>veri sorumlusu</strong> sıfatıyla tek başına
        sorumludur.
      </p>

      <h2>5. Fikri Mülkiyet</h2>
      <p>
        Uygulamanın tüm yazılım, tasarım ve marka hakları Uygulama sahibine
        aittir. Kullanıcı, girdiği içeriklerin sahibidir; içerikler için
        Uygulama'ya yalnızca hizmeti sağlamak için gerekli asgari lisans
        verilmiş sayılır.
      </p>

      <h2>6. Hizmet Değişiklikleri ve Sonlandırma</h2>
      <p>
        Uygulama sahibi, hizmeti önceden bildirimde bulunarak veya bulunmaksızın
        güncelleyebilir, askıya alabilir veya sonlandırabilir. Kullanıcı, dilediği
        zaman "Hesabımı Sil" ile hesabını kapatabilir.
      </p>

      <h2>7. Sorumluluk Sınırı</h2>
      <p>
        Uygulama "olduğu gibi" sunulur. Uygulama sahibi, veri kaybı, kesinti,
        harita katmanlarındaki üçüncü taraf hataları veya konum
        yaklaşıklıklarından doğan zararlardan sorumlu tutulamaz. Kritik
        değerlendirmelerde Kullanıcı'nın kendi mesleki doğrulaması esastır.
      </p>

      <h2>8. Uygulanacak Hukuk</h2>
      <p>
        İşbu şartlar Türkiye Cumhuriyeti hukukuna tabidir. Uyuşmazlıklarda
        Türkiye mahkemeleri ve icra daireleri yetkilidir.
      </p>
    </LegalLayout>
  );
}
